import { useState, useEffect } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { GOLD, fmt, Stat, Field, Card } from './shared';

export const OverheadTab = ({ api, readOnly }) => {
  const [data, setData] = useState({ expenses: [], summary: {} });
  const reload = () => api.get('/accounting/overhead').then(r => setData(r.data)).catch(() => {});
  useEffect(() => { reload(); }, [api]);
  const [form, setForm] = useState({ category: 'office_rent', name: '', monthly_amount: 0, is_fixed: true });
  const add = async () => {
    if (!form.name) return toast.error('Name required');
    try { await api.post('/accounting/overhead', form); setForm({ category: 'office_rent', name: '', monthly_amount: 0, is_fixed: true }); reload(); toast.success('Overhead added'); }
    catch { toast.error('Failed'); }
  };
  const del = async (id) => { try { await api.delete(`/accounting/overhead/${id}`); reload(); } catch { toast.error('Failed'); } };
  const cats = ['owner_compensation', 'employee_wages', 'payroll_taxes', 'workers_comp', 'gl_insurance', 'health_benefits', 'office_rent', 'software', 'phone', 'internet', 'marketing', 'fuel', 'tools', 'legal', 'accounting', 'warranty_reserve', 'other'];
  return (
    <div data-testid="fos-overhead-tab">
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <Stat label="Monthly Overhead" value={fmt(data.summary?.total_monthly)} testid="overhead-monthly" />
        <Stat label="Annual Overhead" value={fmt(data.summary?.total_annual)} accent={GOLD} testid="overhead-annual" />
      </div>
      {!readOnly && (
        <Card className="mb-6">
          <div className="grid sm:grid-cols-4 gap-3 items-end">
            <div>
              <label className="text-xs font-medium text-gray-500">Category</label>
              <select data-testid="oh-category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg text-sm">
                {cats.map(c => <option key={c} value={c}>{c.replace(/_/g, ' ')}</option>)}
              </select>
            </div>
            <Field label="Name" type="text" value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="oh-name" />
            <Field label="Monthly Amount" value={form.monthly_amount} onChange={(v) => setForm({ ...form, monthly_amount: v })} testid="oh-amount" />
            <button data-testid="oh-add-btn" onClick={add} className="h-10 inline-flex items-center justify-center gap-2 px-4 bg-[#C6A87C] text-white text-sm font-medium rounded-lg hover:opacity-90">
              <Plus className="w-4 h-4" /> Add
            </button>
          </div>
        </Card>
      )}
      <Card>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-gray-400 border-b border-gray-200"><th className="py-2">Category</th><th>Name</th><th>Monthly</th><th>Annual</th>{!readOnly && <th></th>}</tr></thead>
          <tbody data-testid="overhead-table">
            {(data.expenses || []).length === 0 && <tr><td colSpan="5" className="py-4 text-gray-400">No overhead recorded.</td></tr>}
            {(data.expenses || []).map(e => (
              <tr key={e.id} className="border-b border-gray-100">
                <td className="py-2 capitalize">{(e.category || '').replace(/_/g, ' ')}</td>
                <td>{e.name}</td>
                <td>{fmt(e.monthly_amount)}</td>
                <td>{fmt(e.annual_amount)}</td>
                {!readOnly && <td><button data-testid={`oh-del-${e.id}`} onClick={() => del(e.id)} className="text-gray-400 hover:text-red-500"><Trash2 className="w-4 h-4" /></button></td>}
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
};
